import * as React from "react";
import ValidatorsLayout from "../components/ValidatorsLayout";

const OrdersValidators: React.FC = () => {
  return (
    <ValidatorsLayout />
  );
};

export default OrdersValidators;